import { ApolloError, ApolloQueryResult } from '@apollo/client';
import { GraphQLError } from 'graphql';

export class ApolloQueryErrorMapper {
	public static getError<T>(queryResult: ApolloQueryResult<T>): ApolloError | ReadonlyArray<GraphQLError> | Error {
		return queryResult.error ?? queryResult.errors ?? new Error('unknown error ocurred');
	}
}
